function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import cx from 'clsx';
import PropTypes from 'prop-types';
import * as React from 'react';
import { childrenUtils, customPropTypes, getComponentType, getUnhandledProps, getKeyOnly } from '../lib';

/**
 * Used in some Button types, such as `animated`.
 */
var ButtonContent = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var children = props.children,
    className = props.className,
    content = props.content,
    hidden = props.hidden,
    visible = props.visible;
  var classes = cx(getKeyOnly(visible, 'visible'), getKeyOnly(hidden, 'hidden'), 'content', className);
  var rest = getUnhandledProps(ButtonContent, props);
  var ElementType = getComponentType(props);
  return /*#__PURE__*/React.createElement(ElementType, _extends({}, rest, {
    className: classes,
    ref: ref
  }), childrenUtils.isNil(children) ? content : children);
});
ButtonContent.displayName = 'ButtonContent';
ButtonContent.propTypes = {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,
  /** Primary content. */
  children: PropTypes.node,
  /** Additional classes. */
  className: PropTypes.string,
  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,
  /** Initially hidden, visible on hover. */
  hidden: PropTypes.bool,
  /** Initially visible, hidden on hover. */
  visible: PropTypes.bool
};
export default ButtonContent;
//# sourceMappingURL=ButtonContent.js.map